import React, { useEffect, useState } from 'react';
import AdminApi from './AdminApi';

const AdminMenuPage = ({ currentMenu, clickChangeMenu }) => {
    const [menus, setMenus] = useState([]);
    const [menuItems, setMenuItems] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        Promise.all([AdminApi.getMenus(), AdminApi.getMenuItems()])
            .then(([menusData, itemsData]) => {
                setMenus(menusData);
                setMenuItems(itemsData);
            })
            .catch(err => console.error("Error fetching menus:", err))
            .finally(() => setIsLoading(false));
    }, []);

    const getMenuName = (menuId) => {
        const menu = menus.find(m => m.id === menuId);
        return menu ? menu.name : 'Unknown';
    };

    return (
        <div className="social-box">
            <h3 className="page-title">Quản lý Menu</h3>
            <div className="header">
                <div className="btn-group">
                    <a className="btn btn-primary" href="#" onClick={e => e.preventDefault()}>
                        <i className="icon-plus" /> Thêm Menu mới
                    </a>
                </div>
            </div>
            <div className="body">
                <h4>Danh sách Menu</h4>
                <table className="table table-hover">
                    <thead>
                        <tr>
                            <th>Tên Menu</th>
                            <th>Mã (Code)</th>
                            <th>Ngôn ngữ</th>
                            <th>Cấp độ tối đa</th>
                            <th width="150px">Thao tác</th>
                        </tr>
                    </thead>
                    <tbody>
                        {menus.map(menu => (
                            <tr key={menu.id}>
                                <td><strong>{menu.name}</strong></td>
                                <td><code>{menu.code}</code></td>
                                <td>{menu.lang}</td>
                                <td>{menu.maxLevel}</td>
                                <td>
                                    <a className="btn btn-info btn-small" href="#" onClick={e => {e.preventDefault(); alert('Tính năng đang được phát triển.');}} style={{marginRight: '5px'}}>
                                        <i className="icon-list" /> Chi tiết
                                    </a>
                                    <a className="btn btn-success btn-small" href="#" onClick={e => {e.preventDefault(); alert('Tính năng đang được phát triển.');}}>Sửa</a>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                <h4 style={{marginTop: '30px'}}>Danh sách Item trong Menu</h4>
                <table className="table table-hover">
                    <thead>
                        <tr>
                            <th>Tên Item</th>
                            <th>URL</th>
                            <th>Menu</th>
                            <th>Thứ tự</th>
                            <th>Cấp độ</th>
                            <th>Kích hoạt</th>
                            <th width="150px">Thao tác</th>
                        </tr>
                    </thead>
                    <tbody>
                        {isLoading ? (
                            <tr><td colSpan="7" className="text-center">Đang tải...</td></tr>
                        ) : (
                            menuItems.map((item) => (
                                <tr key={item.id}>
                                    <td><strong>{item.name}</strong></td>
                                    <td>{item.url}</td>
                                    <td>{getMenuName(item.menu)}</td>
                                    <td>{item.order}</td>
                                    <td>{item.level}</td>
                                    <td>
                                        <input type="checkbox" checked={item.active} readOnly />
                                    </td>
                                    <td>
                                        <a className="btn btn-success btn-small" href="#" onClick={e => e.preventDefault()}>
                                            <i className="coloredicon page-white-edit" /> Sửa
                                        </a>
                                        <a className="btn btn-danger btn-small" href="#" onClick={e => e.preventDefault()}>
                                            <i className="coloredicon delete" /> Xóa
                                        </a>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AdminMenuPage;
